
/* eslint-disable */
import { getLayoutData, getPages} from '../api/api';
import React from 'react';
import {Projects, VideoBanner, StickyHeading} from "@repo/ui";
import {CONTENT_TYPES, CONTENT_TYPES as COMMON_CONTENT_TYPES} from '@repo/utils/constants';
import { CONTENT_TYPES as DIGITAL_CONTENT_TYPES } from "@/utils/constants";

export default function ProjectsPage({ data, globals, locale }) {
	const content = data?.content || [];
	const checkOthers  = data?.checkothers || {}
	const filters = data?.filters || [];
	const videoBanner = { banner: data?.banner || {}, video:  data?.video || {}}
	const desc = {
		slogan: [data?.descriptionSlogan?.slogan1 || '', data?.descriptionSlogan?.slogan2 || ''],
		button: data?.descriptionSlogan?.button || {},
		description: data?.descriptionSlogan?.description || {},
	}
	const projectsTable = data?.projectsTable || []
	return (
		<>
			<StickyHeading stickyHeadingsSelectors={[]} />
			<VideoBanner data={videoBanner} key="projects" webGL />
			<Projects
				data={content}
				desc={desc}
				filters={filters}
				checkOthers={checkOthers}
				types={DIGITAL_CONTENT_TYPES}
				projectsTable={projectsTable}
				webGL
			/>
		</>
	);
}

const query = `
	query GetAllProjectsPageData($locale: SiteLocale) {
		digitalAllProjectsPage(locale: $locale) {
			title
			name
			slug
			_seoMetaTags {
				attributes
				content
				tag
			}
			banner {
			  header{
				text
				breaks{
				  image{
					url
					alt
				  }
				}
			  }
			  text{
				id
				text{
					text
					breaks{
						id
						image{
							url
							alt
						}
					}
				}
			  }
			  variant
			}
			video {
				horizontal{
				  url
				}
				vertical{
				  url
				}
		  	}
			breadcrumbs {
				text
				id
				link {
					... on ${DIGITAL_CONTENT_TYPES.ALL_PROJECTS_PAGE} {
						slug
					}
					... on ${DIGITAL_CONTENT_TYPES.SINGLE_PAGE} {
						slug
					}
					... on ${DIGITAL_CONTENT_TYPES.SINGLE_PROJECT} {
						slug
					}
							
					... on ${DIGITAL_CONTENT_TYPES.SINGLE_HOW_WE_WORK_PAGE_NEW} {
						slug
					}
				}
			}
			themeLight {
				mainPrimary {
					hex
				}
				mainSecondary {
					hex
				}
				mainTertiary {
					hex
				}
				extraPrimary {
					hex
				}
				extraSecondary {
					hex
				}
				extraTertiary {
					hex
				}
			}
			themeDark {
				mainPrimary {
					hex
				}
				mainSecondary {
					hex
				}
				mainTertiary {
					hex
				}
				extraPrimary {
					hex
				}
				extraSecondary {
					hex
				}
				extraTertiary {
					hex
				}
			}
			filters {
				... on ${COMMON_CONTENT_TYPES.PROJECT_CATEGORY} {
					projectCategory
					projectCategoryId
				}
			}
			descriptionSlogan {
			  description
			  slogan1
			  slogan2
			  button {
				text
				link {
			      ... on ${DIGITAL_CONTENT_TYPES.SINGLE_PAGE} {
					slug
			  	  }
				  ... on ${DIGITAL_CONTENT_TYPES.SINGLE_PROJECT} {
					slug
				  }				 
				  ... on ${DIGITAL_CONTENT_TYPES.SINGLE_HOW_WE_WORK_PAGE_NEW} {
				  	slug
				  }
				}
			  }
			}
			content {
				__typename
				... on ${DIGITAL_CONTENT_TYPES.SINGLE_PROJECT}  {
						id
						name
						description
						slug
						highlight
						projectColor {
							hex
						}
						project
						projectCategories {
							projectCategory
							projectCategoryId
						}
						projectServiceRange {
							serviceName
						}
						year
						themeLight {
							mainPrimary {
								hex
							}
							mainSecondary {
								hex
							}
							mainTertiary {
								hex
							}
							extraPrimary {
								hex
							}
							extraSecondary {
								hex
							}
							extraTertiary {
								hex
							}
						}
						themeDark {
							mainPrimary {
								hex
							}
							mainSecondary {
								hex
							}
							mainTertiary {
								hex
							}
							extraPrimary {
								hex
							}
							extraSecondary {
								hex
							}
							extraTertiary {
								hex
							}
						}
						coverPortrait {
							url
							width
							height
							mimeType
						}
						coverLandscape {
							url
							width
							height
							mimeType
						}
						video {
						  	url
						  	width
							height
							mimeType
						}
						description
						bannerWhiteLogo
						bannerWhiteMenu
			  	}
				... on ${COMMON_CONTENT_TYPES.PROJECTS_GRID} {
					id
					indent
					grid {
					  __typename
					  ... on ${COMMON_CONTENT_TYPES.TEXT_SMALL_IMAGE} {
					  	id
						text
						asset{
						  asset {
							url
							mimeType
							id
							width
							height
						  }
						}
					  }
					  ... on ${COMMON_CONTENT_TYPES.TEXT_WITH_BREAK} {
						id
						text {
						  text
						  breaks {
							image {
							  url
							  alt
							  width
							  height
							}
						  }
						}
					  }
					  ... on ${DIGITAL_CONTENT_TYPES.SINGLE_PROJECT} {
					  	id
						name
						slug
						description
						highlight
						projectColor {
							hex
						}
						project
						projectCategories {
							projectCategory
							projectCategoryId
						}
						projectServiceRange {
							serviceName
						}
						year
						themeLight {
							mainPrimary {
								hex
							}
							mainSecondary {
								hex
							}
							mainTertiary {
								hex
							}
							extraPrimary {
								hex
							}
							extraSecondary {
								hex
							}
							extraTertiary {
								hex
							}
						}
						themeDark {
							mainPrimary {
								hex
							}
							mainSecondary {
								hex
							}
							mainTertiary {
								hex
							}
							extraPrimary {
								hex
							}
							extraSecondary {
								hex
							}
							extraTertiary {
								hex
							}
						}
						coverPortrait {
							url
							width
							height
							mimeType
						}
						coverLandscape {
							url
							width
							height
							mimeType
						}
						video {
						  url
						  width
						  height
						  mimeType
						}
						description
						bannerWhiteLogo
						bannerWhiteMenu
					  }
					}
				  }
				... on ${COMMON_CONTENT_TYPES.HORIZONTAL_HEADER} {
					title
					text
				}
			}
			checkothers {
			  	id
				contactHeader
				checkOthersHeader
				text {
				  text {
					text
					breaks {
					  image{
						url
					  }
					}
				  }
				}
				links {
				  ... on ${DIGITAL_CONTENT_TYPES.SINGLE_PAGE} {
					slug
					name
				  }
				  ... on ${DIGITAL_CONTENT_TYPES.ALL_PROJECTS_PAGE} {
					slug
					name
				  }
				}
			}
			projectsTable {
				id
				buttonText
				header
				headers {
					text
				}
				paddings {
					top
					bottom
				}
				loadMoreButtonText
				showLoadMoreButton
				items {
					title
					client
					industry
					year
					externalUrl
					chooseProject {
					  __typename
					  ... on DigitalSingleProjectRecord{
						name
						slug
					  }
					  ... on DesignSingleProjectRecord{
						name
						slug
					  }
					}
					cursorAsset {
						id
						width
						height
						url
						alt
						mimeType
					}
					shouldOpenInNewTab
					servicesAndCompetences {
						__typename
						... on ${CONTENT_TYPES.COMPETENCES_PAGE_RECORD} {
							id          
							name: competenceName
							slug
						}
						... on ${CONTENT_TYPES.SERVICE_PAGE_RECORD} {
							id
							name: serviceName
							slug
						}
					}
					technologiesAndTools {
						__typename
						... on ${CONTENT_TYPES.PROJECT_TECHNOLOGY_RECORD} {
							id
							name: projectTechnologyName
							slug
						}
					}
				}
			}
		}
	}
`;

export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPages('digitalAllProjectsPage', query, locale);
	const { globals, cookies, menu, footer } = await getLayoutData(locale)
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			menu,
			footer
		},
	};
}
